export const Bio = {
  name: "Lakshay Dhoundiyal",
  roles: [
    "Software Engineer",
    "Security Researcher",
    "Red Teamer",
    "Ethical Hacker",
    "Pentester",
    "Graphic Designer",
    "SEO Expert",
    "Blogger",
    "Content Writer",
    "Freelancer",
  ],
  description:
  "World Record Holder with a Master’s in IT, specializing as a Software Engineer & Cybersecurity Researcher. I design and develop scalable, high-performance web applications, integrate robust security measures, and conduct research to counter emerging cyber threats. My user-focused methodology ensures each solution is intuitive and resilient for seamless user experiences.",
  resume: "https://drive.google.com/file/d/1UyYltHXVArj85EQPt2oSAkBI34C4mP5J/view?usp=drive_link",
  record: "https://www.internationalbookofrecords.com/records/youngest-to-complete-maximum-internships/",
  linkedin: "https://www.linkedin.com/in/lakshay-dhoundiyal-531b25259",
  hashnode: "https://hashnode.com/@LakshayDhoundiyal",
  github: "https://github.com/LakshayD02",
  topmate: "https://topmate.io/lakshay_dhoundiyal",
  leetcode: "https://indiabookofrecords.in/maximum-virtual-and-remote-internships-completed-by-an-individual-in-different-domains/",
  hackerrank: "https://lakshay-dhoundiyal-publications.vercel.app",
  blogger: "https://lakshaydhoundiyal-cybersec.vercel.app/",
  discord: "https://discordapp.com/users/1012260127430164531",
};

export const skills = [
  {
    title: "Frontend Development",
    skills: [
      {
        name: "TypeScript",
        image:
          "https://i.ibb.co/8gB44wkj/Typescript.png",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "Sass",
        image:
          "https://i.ibb.co/JRVW7L33/Sass.png",
      },
        {
        name: "Angular",
        image:
          "https://i.ibb.co/sbt68HD/Angular.png",
      },
       {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "JavaScript",
        image:
          "https://i.ibb.co/1JPqBnm2/JS.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
     {
        name: "React.Js",
        image: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Tailwind",
        image:
          "https://i.ibb.co/v3MV4p3/tAILWIND.png",
      },
       {
        name: "CSS3",
        image:
          "https://i.ibb.co/BJKp7zS/CSS3.png",
      },
    ],
  },
  {
    title: "Backend Development",
    skills: [
      {
        name: "NodeJs",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "ExpressJs",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Golang",
        image: "https://i.ibb.co/PZMT1rHm/GO.png",
      },
       {
        name: "Java",
        image: "https://i.ibb.co/C3WrzV1f/Java.png",
      },
      {
        name: "Socket.io",
        image:
          "https://i.ibb.co/CMCTKGn/socket.png",
      },
      {
        name: "Payload",
        image:
          "https://i.ibb.co/8T8WfRF/Payload.webp",
      },
      {
        name: "Wrangler",
        image:
          "https://i.ibb.co/m5DjqwFp/wrangler.jpg",
      },
       {
        name: "PHP",
        image: "https://i.ibb.co/fCfDPSs/PHP.png",
      },
       {
        name: "Microservices",
        image:
          "https://i.ibb.co/MyRwCzZq/microservices.jpg",
      },
      {
        name: "Cloudflare Workers",
        image:
          "https://i.ibb.co/f6sG1Vh/Cloudflare.png",
      },
    ],
  },
  {
    title: "Libraries & Frameworks",
    skills: [
       {
        name: "Django",
        image:
          "https://i.ibb.co/Vcbb6Q4B/Django-1.png",
      },
      {
        name: "Flask",
        image:
          "https://i.ibb.co/bHLBPRM/cover-flask.jpg",
      },
      {
        name: "FastAPI",
        image:
          "https://i.ibb.co/r2LKY5ZR/Fast-API.png",
      },
      {
        name: "Three.Js",
        image: "https://i.ibb.co/hx1PcCCv/ThREEJS.png",
      },
      {
        name: "Laravel",
        image:
          "https://i.ibb.co/j9fC9RpS/Laravel.webp",
      },
      {
        name: "Framer",
        image:
          "https://i.ibb.co/WvsqfM4r/Framer.png",
      },
      {
        name: "npm",
        image:
          "https://i.ibb.co/CbnNtsQ/npm.png",
      },
      {
        name: "Yarn",
        image:
          "https://i.ibb.co/MChvz4K/yarn.jpg",
      },
      {
        name: "Jquery",
        image:
          "https://i.ibb.co/tBwBxXT/JQUERY.png",
      },
      {
        name: "GSAP",
        image:
          "https://i.ibb.co/zTwW5WWG/GSAP.webp",
      },
      {
        name: "Axios",
        image:
          "https://i.ibb.co/PZYx2VfB/Axios.webp",
      },
      {
        name: "Vue.Js",
        image:
          "https://i.ibb.co/G4fGS7DR/Vue.png",
      },
    ],
  },
  {
    title: "Authentication & API's",
    skills: [
      {
        name: "clerk Auth",
        image:
          "https://i.ibb.co/6fPwLXW/Clerk.png",
      },
       {
        name: "RBAC",
        image:
          "https://i.ibb.co/pBF5nvH7/rbac.png",
      },   
      {
        name: "Oauth 2.0",
        image:
          "https://i.ibb.co/cX3qnYks/Oauth.webp",
      },
      {
        name: "REST API",
        image:
          "https://i.ibb.co/3bCfGHw/rest.jpg",
      },
      {
        name: "Websockets",
        image:
          "https://i.ibb.co/bjMhT3Fb/websockets.png",
      },
      {
        name: "Kinde",
        image:
          "https://i.ibb.co/M5ZVK3W0/Kinde.jpg",
      },
      {
        name: "Webhooks",
        image:
          "https://i.ibb.co/ZzBrFmJ7/webhook.jpg",
      },
      {
        name: "GraphQL",
        image:
          "https://i.ibb.co/bjWK3XC6/graphql.webp",
      },
      {
        name: "gRPC",
        image:
          "https://i.ibb.co/WWQj3rSM/g-RPC.png",
      },
       {
        name: "JWT",
        image:
          "https://i.ibb.co/60N1WyhF/jwt.png",
      },
      {
        name: "JSON",
        image:
          "https://i.ibb.co/B5S9fCYp/json.png",
      },     
      {
        name: "HTTP/HTTPS",
        image:
          "https://i.ibb.co/jPPfZZch/http.png",
      },         
    ],
  },
   {
    title: "Database & Queuing",
    skills: [
       {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
       {
        name: "Redis",
        image: "https://i.ibb.co/Q71Nx4rB/redis.png",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
       {
        name: "Prisma",
        image: "https://i.ibb.co/RkJ21XyZ/prisma.jpg",
      },
       {
        name: "Supabase",
        image: "https://i.ibb.co/Q331WxX5/Supabase.png",
      },
      {
        name: "RabbitMQ",
        image: "https://i.ibb.co/Y7KPjhVp/rabbitmq.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Appwrite",
        image:
          "https://i.ibb.co/7x7F86Ph/appwrite.png",
      },
       {
        name: "Mongoose",
        image: "https://i.ibb.co/Y4tkW4D2/mongoose.png",
      },
       {
        name: "SQLite",
        image: "https://i.ibb.co/cXD4r46x/sqlite.jpg",
      },
       {
        name: "Kafka",
        image: "https://i.ibb.co/21LXC3Vd/kafka.jpg",
      },
      
    ],
  },
  {
    title: "Cloud & DevOps",
    skills: [
       {
        name: "Nginx",
        image: "https://download.logo.wine/logo/Nginx/Nginx-Logo.wine.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
     {
        name: "Grafana",
        image:
          "https://i.ibb.co/Zp70bybz/grafana.jpg",
      },
       {
        name: "Kubernetes",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
      },
        {
        name: "Prometheus",
        image:
          "https://i.ibb.co/MDHJDQJr/Prometheus.webp",
      },
       {
        name: "AWS S3",
        image:
          "https://i.ibb.co/mr2P63ZR/s3.webp",
      },
       {
        name: "Actions",
        image:
          "https://i.ibb.co/bc7Ts58/actions.png",
      },
       {
        name: "Vagrant",
        image: "https://i.ibb.co/RTS2tjZ4/Vagrant.png",
      },
       {
        name: "AWS IAM",
        image:
          "https://i.ibb.co/Hp469Wv8/iam.png",
      },
       {
        name: "Jenkins",
        image:
          "https://toppng.com/uploads/preview/jenkins-logo-11609365847mufysaivph.png",
      },
       {
        name: "AWS CLI",
        image:
          "https://i.ibb.co/vCkxhzLn/cli.png",
      },
    ],
  },
  {
    title: "Developer Tools",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://i.ibb.co/L7y02XB/VS.webp",
      },
      {
        name: "Postman",
        image:
          "https://i.ibb.co/FqyGzryp/postman.png",
      },
      {
        name: "Arduino",
        image:
          "https://i.ibb.co/28dsL2f/arduino.png",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
      {
        name: "Canva",
        image:
          "https://i.ibb.co/4Nf3K2W/Canva-logo.png",
      },
      {
        name: "Atom",
        image:
          "https://i.ibb.co/S6dFZ2Q/Atom.jpg",
      },
      {
        name: "IntelliJ",
        image:
          "https://i.ibb.co/FJR5SKT/IntelliJ.jpg",
      },
      {
        name: "Sublime",
        image:
          "https://i.ibb.co/1RLVvNp/Sublime.png",
      },
      {
        name: "PyCharm",
        image:
          "https://i.ibb.co/H45FpS7/Pycharm.png",
      },
    ],
  },
 {
    title: "Security & Pentesting",
    skills: [
      {
        name: "Kali Linux",
        image:
          "https://i.ibb.co/fXcP1QT/Kali-l-Inux.png",
      },
       {
        name: "Shodan",
        image:
          "https://i.ibb.co/qYjzzCbS/Shodan.png",
      },
       {
        name: "Aircrack",
        image:
          "https://i.ibb.co/HTP6mVF/Aircrack.jpg",
      },
      {
        name: "Metasploit",
        image:
          "https://i.ibb.co/mGVPKQx/Metasploit.png",
      },
       {
        name: "Gobuster",
        image:
          "https://i.ibb.co/Zpx0G06M/gobuster.jpg",
      },
       {
        name: "Nikto",
        image:
          "https://i.ibb.co/vx0rf5QT/Nikto.png",
      },
      {
        name: "BurpSuite",
        image:
          "https://i.ibb.co/XVzS20Z/Burp-Suite.jpg",
      },
      {
        name: "Wireshark",
        image:
          "https://i.ibb.co/ScHfYfb/Wiresharj.jpg",
      },
       {
        name: "NMAP",
        image:
          "https://i.ibb.co/hgKpnRK/NMPA.png",
      },
      {
        name: "Armitage",
        image:
          "https://i.ibb.co/VDWn4Jx/Armitage.jpg",
      },
      {
        name: "Nessus",
        image:
          "https://i.ibb.co/xS7m5kQf/Nessus-1.png",
      },
      {
        name: "SQLMap",
        image:
          "https://i.ibb.co/r2TmY7M/SQLmap.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 1,
    img: "https://i.ibb.co/cXM2dWkb/Samarth.jpg",
    role: "Research Intern (Full Stack)",
    company: "Samarth e-Gov, CPS Lab",
    date: "December, 2025 - April, 2026",
    desc: "Built and deployed the IIC Official Website using Next.js, TypeScript, and Tailwind CSS, integrating Payload CMS to enable full content management in a live production environment. Designed and developed the SamarthX Goa School Website from scratch and integrating Payload CMS for production readiness.",
    skills: [
      "Nextjs",
      "Typescript",
      "Tailwind CSS",
      "Payload CMS",
      "MongoDB",
      "REST API'S",
      "Cloudinary",
      "Bootstrap",
      "CSS",
      "JavaScript",
      "HTML",
    ],
    internshipCert: "https://i.ibb.co/6cXRJtn1/CPS-Certificate.jpg",
    lor: "https://i.ibb.co/zWRRCvL5/CPS-NOC.jpg",
  },
  {
    id: 2,
    img: "https://i.ibb.co/CxxQ8zQ/Infosys.webp",
    role: "Data Visualization Intern",
    company: "Infosys Springboard",
    date: "January, 2025 - April, 2026",
    desc: "Analyzed food consumption trends and customer preferences using structured datasets to identify key patterns and insights. Designed and developed interactive dashboards using data visualization tools to present actionable insights.",
    skills: [
      "Data Analysis",
      "Data Visualization",
      "Dashboard Development",
      "EDA",
      "Excel",
      "Analytics",
      "Business Insights",
      "Pandas",
      "Python",
      "Numpy",
      "Insight Generation",
    ],
    internshipCert: "https://i.ibb.co/PGSp3knP/Infosys.jpg",
    lor: "https://i.ibb.co/XfTqzSsw/Screenshot-2026-04-19-175717.png",
  },
  {
    id: 3,
    img: "https://i.ibb.co/ZzQGPC5n/Celebal.png",
    role: "React Dev Intern",
    company: "Celebal Technologies",
    date: "June, 2025 - August, 2025",
    desc: "Built a responsive eCommerce web application using ReactJS, featuring product listings, search, cart, checkout, and authentication. Integrated REST APIs for real-time data handling and used Redux and Context API for efficient state management.",
    skills: [
      "ReactJS",
      "Redux",
      "Context API",
      "Axios",
      "JavaScript",
      "HTML",
      "CSS",
      "React Router",
      "Responsive Design",
      "JSON",
      "Bootstrap",
      "Tailwind CSS",
      "MySQL",
    ],
    internshipCert: "https://i.ibb.co/bg5c8s0Y/Celebal.jpg",
    lor: "https://i.ibb.co/bg5c8s0Y/Celebal.jpg",
  },
  {
    id: 102,
    img: "https://i.ibb.co/mVtc0xcK/I4C.jpg",
    role: "Cyber Security & VAPT Intern",
    company: "I4C, Ministry of Home Affairs",
    date: "May, 2025 - July, 2025",
    desc: "Conducted OSINT investigations and monitored surface and dark web sources to identify exposed credentials. Performed vulnerability assessments and penetration tests to identify security gaps and provide remediation recommendations.",
    skills: [
      "Kali Linux",
      "Maltego",
      "Shodan",
      "Burpsuite",
      "Wireshark",
      "Nmap",
      "Nessus",
      "Nikto",
      "TOR",
      "Metasploit",
      "theHarvester",
    ],
    internshipCert: "https://i.ibb.co/rRTbZDCw/I4-CCertificate.jpg",
    lor: "https://i.ibb.co/vxXVHsrB/14CLOR.jpg",
  },
  {
    id: 105,
    img: "https://i.ibb.co/PZ3G28Dr/Hackers-Daddy.jpg",
    role: "Penetration Tester",
    company: "HackersDaddy Cybersecurity Solutions",
    date: "December, 2024 - March, 2025",
    desc: "Identified and exploited vulnerabilities like XSS, IDOR, File upload and access control flaws. Mastered tools like Nmap for port and servuce enumeration. Conducted directory bruteforcing with GoBuster, documented and reported the solutions in a structured manner.",
    skills: [
      "Kali Linux",
      "Python",
      "Scapy",
      "Burpsuite",
      "Wireshark",
      "Nmap",
      "SQLmap",
      "Aircrack-ng",
      "Netcat",
      "Hashcat",
    ],
    internshipCert: "https://i.ibb.co/BHbkTHdf/Hackers-Daddy-CPPT.jpg",
    lor: "https://i.ibb.co/HT6Ymzhh/Lakshay-Dhoundiyal-Experience-letter-page-0001.jpg",
  },
  {
    id: 101,
    img: "https://i.ibb.co/2kHyB8G/coding-bits.png",
    role: "Full Stack Web Developer",
    company: "Coding Bits",
    date: "November, 2024 - February, 2025",
    desc: "Assisted in enhancing and maintaining the Coding Bits Website, improved user experience and functionality through various optimizations. Integrated Stripe payment gateway into the Coding Bits website, handling both front-end and back-end integration.",
    skills: [
      "MERN Stack",
      "Firebase",
      "MySQL",
      "PHP",
      "Git",
      "GitHub",
      "Python",
      "AWS",
      "Figma",
      "Tailwind CSS",
    ],
    internshipCert: "https://i.ibb.co/BDTZ9YW/Coding-Bits-Certificate-1.png",
    lor: "https://i.ibb.co/60grSKMC/Coding-Bits-LOR.jpg",
  },
  {
    id: 3,
    img: "https://i.ibb.co/19nd3mk/Center-for-Cyber-Security-Studies-Research-1.png",
    role: "Cyber Security Intern",
    company: "Centre For Cyber Security Studies & Research",
    date: "July, 2024 - October, 2024",
    desc: "Monitored and analyzed security incidents, assisted in vulnerability assessments and penetration testing. Contributed to the development and implementation of security policies and procedures and conducted research on emerging threats.",
    skills: [
      "Pentesting",
      "Firewalls",
      "IDS & IPS",
      "TCP/IP Protocols",
      "Kali Lnux",
      "VAPT",
      "MatplotLib",
      "DoS and DDoS",
      "Windows Security",
    ],
    internshipCert: "https://i.ibb.co/GTY3zcZ/CFCS2-R-Certificate.png",
    lor: "https://i.ibb.co/5h5NYMKR/CFCS2-R-LOR.jpg",
  },
];

export const education = [
  {
    id: 0,
    img: "https://i.ibb.co/72TGtwP/iiclogo.jpg",
    school: "M.Sc. Informatics",
    date: "August, 2024 - July, 2026",
    grade: "8.41 CGPA | Regular",
    desc: "Completed my Master's degree in Informatics (IT) from the Institute of Informatics and Communication, UDSC. Secured 1st rank in my department during the first year and served as the Placement Coordinator of the Placement Cell, where I had been actively involved in organizing placement activities.",
    degree: "Institute of Informatics and Communication (IIC), UDSC",
    institutionUrl: "https://i.ibb.co/23tPZjVb/IIC.png",
    websiteUrl: "https://iic-udsc.vercel.app/",
  },
  {
    id: 1,
    img: "https://i.ibb.co/V9v1q6B/ignou.jpg",
    school: "Advance Certificate Course in Information Security (ACISE)",
    date: "August, 2024 - July, 2026",
    grade: "Certification | Total Semester - 1",
    desc: "Pursued 6 months Advanced certification program in Information Security from Indra Gandhi National Open University (IGNOU), Delhi. Coursework includes Information Security, Securing Internet Access, Information Technology Security and Server Security.",
    degree: "Indra Gandhi National Open University (IGNOU), Noida Regional Centre",
    websiteUrl: "https://www.ignou.ac.in/",
    institutionUrl: "https://i.ibb.co/ynLsc4G1/IGNOUNoida.jpg",
  },
  {
    id: 2,
    img: "https://i.ibb.co/thL9Pnv/ARSD.jpg",
    school: "B.Sc. (Hons.) Electronics",
    date: "November, 2021 - July, 2024",
    grade: "8.32 CGPA | Regular",
    desc: "Graduated with a Bachelor's Degree in Electronics from ARSD College, Delhi University, securing an aggregate CGPA of 8.32. I received the Meritorious Student Award three times consecutively (2022-2025) and contributed as the Technical Head and Vice President of ElectroSpark, the Electronics Society of ARSD College.",
    degree: "Atma Ram Sanatan Dharma College, Delhi University",
    websiteUrl: "https://arsdcollege.ac.in/",
    institutionUrl: "https://i.ibb.co/Z6ftRzHD/ARSD.jpg",
  },
  {
    id: 3,
    img: "https://i.ibb.co/zmsyPzp/GDS.jpg",
    school: "Diploma in Ethical Hacking",
    date: "January, 2024 - August, 2024",
    grade: "Certification | Score : 90%",
    desc: "Completed an 8-month online Diploma and Training Course in Ethical Hacking. The program covered relevant coursework in CCNA, Linux Certification Training, Networking, Operating Systems, CEH, Bug Bounty Hunting, Cyber Law and Forensics, Mobile Hacking, and Cloud Computing.",
    degree: "Global Defensive Security, Bhopal",
    institutionUrl: "https://in.linkedin.com/company/globaldefensivesecurity",
    websiteUrl: "https://globaldefensivesecurity.com/",
  },
  {
    id: 4,
    img: "https://i.ibb.co/nMQWsMK/RIS.jpg",
    school: "Intermediate - 12th",
    date: "April, 2020 - July, 2021",
    grade: "93%",
    desc: "Completed my Intermediate (Science Stream) at Ramjas International School, with subjects including Physics, Chemistry, Maths, English, Economics, and Physical Education. Participated in Basketball, Cricket, Football, and Badminton. Awarded with the Veer Chandra Singh Garhwali Medhavi Chhatra Sammaan.",
    degree: "Ramjas International School, R.K Puram",
    institutionUrl: "https://i.ibb.co/k2Tt9q12/Ramjas.webp",
    websiteUrl: "https://ramjasschoolrkpuram.com/",
  },
  {
    id: 5,
    img: "https://i.ibb.co/nMQWsMK/RIS.jpg",
    school: "Matriculation - 10th",
    date: "April, 2018 - May, 2019",
    grade: "93%",
    desc: "Completed my Matriculation at Ramjas International School, with subjects including Maths, Science, English, SST, Hindi, and Foundations of IT. Actively participated in Basketball, Cricket, Football, and Badminton. Awarded the Veer Chandra Singh Garhwali Medhavi Chhatra Sammaan in 2019.",
    degree: "Ramjas International School, R.K Puram",
    institutionUrl: "https://i.ibb.co/k2Tt9q12/Ramjas.webp",
    websiteUrl: "https://ramjasschoolrkpuram.com/",
  },
];

export const projects = [
  {
    id: 113,
    title: "SafeSphere AI",
    date: "July 2026",
    description:
      "It is an advanced, AI-powered threat analysis and fact-checking platform designed to analyze social media content.",
    image:
      "https://i.ibb.co/RTvYfD0d/40.png",
    category: "web app",
    github: "https://github.com/LakshayD02/SafeSphere-AI_Fake_News-_Detection_Platform",
    webapp: "https://safesphere-lakshay.vercel.app/",
    member: [
      {
        img: "https://i.ibb.co/d4hG9tn/react-icon-2048x2048-o8k3ymqa.png",
      },
     {
        img: "https://i.ibb.co/QFBQTdqt/Nextjs.png",
      },
     {
        img: "https://i.ibb.co/v3MV4p3/tAILWIND.png",
      },
       {
        img: "https://i.ibb.co/gTdrqbD/Express.png",
      },
      {
        img: "https://i.ibb.co/Yh7mRx1/Node.png",
      },
      {
        img: "https://i.ibb.co/RyN9DQW/Type-Script.jpg",
      },
       {
        img: "https://i.ibb.co/4tRMc8X/Mongo.png",
      },
      {
        img: "https://i.ibb.co/6RgktB2c/Qsrant.webp",
      },
    ],
  },
  {
    id: 112,
    title: "TripPlanner ELD",
    date: "June 2026",
    description:
      "It is a web application designed for property-carrying truck drivers and fleet operators to plan optimal routes.",
    image:
      "https://i.ibb.co/nZdjv8G/41.png",
    category: "web app",
    github: "https://github.com/LakshayD02/ELD_Route_Planner_Django",
    webapp: "https://eld-route-planner-lakshay.vercel.app/",
    member: [
      {
        img: "https://i.ibb.co/d4hG9tn/react-icon-2048x2048-o8k3ymqa.png",
      },
     {
        img: "https://i.ibb.co/crvXqds/django.png",
      },
     {
        img: "https://i.ibb.co/v3MV4p3/tAILWIND.png",
      },
       {
        img: "https://i.ibb.co/fzbJJDZJ/material.webp",
      },
      {
        img: "https://i.ibb.co/MxcDDfqM/SQLite.webp",
      },
      {
        img: "https://i.ibb.co/ZpZM87Wx/leaflet.webp",
      },
    ],
  },
  {
    id: 111,
    title: "Threadly: B2B SaaS",
    date: "April 2026",
    description:
      "A team communication platform that combines real-time messaging, AI-powered insights, and intelligent thread organization.",
    image:
      "https://i.ibb.co/kg61CQjg/36.png",
    category: "web app",
    github: "https://github.com/LakshayD02/",
    webapp: "https://threadly-ai-lakshay.vercel.app/",
    member: [
      {
        img: "https://i.ibb.co/d4hG9tn/react-icon-2048x2048-o8k3ymqa.png",
      },
     {
        img: "https://i.ibb.co/QFBQTdqt/Nextjs.png",
      },
     {
        img: "https://i.ibb.co/v3MV4p3/tAILWIND.png",
      },
       {
        img: "https://i.ibb.co/23DDqTJB/prisma.jpg",
      },
      {
        img: "https://i.ibb.co/qYPHsMRX/arcjet.jpg",
      },
      {
        img: "https://i.ibb.co/r2LKY5ZR/Fast-API.png",
      },
      {
        img: "https://i.ibb.co/S42VDw7g/Kinde.webp",
      },
      {
        img: "https://i.ibb.co/ynF0rRCn/Postgre-SQL.webp",
      },
    ],
  },
  
  {
    id: 110,
    title: "Carvix: Car Marketplace",
    date: "October 2025",
    description:
      "A modern, full-stack SaaS platform featuring car buying with AI-powered image search, automated data extraction, and seamless test drive booking.",
    image:
      "https://i.ibb.co/YBdCHZVS/Carvix.png",
    category: "web app",
    github: "https://github.com/LakshayD02/Carvix_AI_Powered_Car_Marketplace",
    webapp: "https://carvix-ai-lakshay.vercel.app",
    member: [
      {
        img: "https://i.ibb.co/d4hG9tn/react-icon-2048x2048-o8k3ymqa.png",
      },
     {
        img: "https://i.ibb.co/QFBQTdqt/Nextjs.png",
      },
     {
        img: "https://i.ibb.co/v3MV4p3/tAILWIND.png",
      },
      {
        img: "https://i.ibb.co/ymwkLv5z/Supabase.png",
      },
      {
        img: "https://i.ibb.co/wFHGWVLP/shadcn.png",
      },
      {
        img: "https://i.ibb.co/23DDqTJB/prisma.jpg",
      },
      {
        img: "https://i.ibb.co/qYPHsMRX/arcjet.jpg",
      },
      {
        img: "https://i.ibb.co/wrbfv07L/clerk.jpg",
      },
      {
        img: "https://i.ibb.co/qMWYC8qz/gemini.webp",
      },
    ],
  },
  
  {
    id: 11,
    title: "Carbonwise: Track Carbon",
    date: "July 2025",
    description:
      "CarbonWise is a Full Stack web app designed to help individuals track, analyze & reduce their carbon footprint",
    image:
      "https://i.ibb.co/nqR0cxbJ/Carbonwise.png",
    category: "web app",
    github: "https://github.com/LakshayD02/CarbonWise-Carbon-Tracker",
    webapp: "https://carbonwise-lakshay.vercel.app/",
    member: [
     {
        img: "https://i.ibb.co/QFBQTdqt/Nextjs.png",
      },
       {
        img: "https://i.ibb.co/RyN9DQW/Type-Script.jpg",
      },
     {
        img: "https://i.ibb.co/v3MV4p3/tAILWIND.png",
      },
      {
        img: "https://i.ibb.co/d4hG9tn/react-icon-2048x2048-o8k3ymqa.png",
      },
      {
        img: "https://i.ibb.co/ymwkLv5z/Supabase.png",
      },
      {
        img: "https://i.ibb.co/wFHGWVLP/shadcn.png",
      },
      {
        img: "https://i.ibb.co/gTdrqbD/Express.png",
      },
      {
        img: "https://i.ibb.co/Yh7mRx1/Node.png",
      },
    ],
  },
  {
    id: 114,
    title: "MacOS Portfolio",
    date: "May 2026",
    description:
      "A stunning, interactive macOS-inspired portfolio website built with Next.js, Shadcn and Tailwind CSS.",
    image:
      "https://i.ibb.co/Mk34Bj9k/42.png",
    category: "web app",
    github: "https://github.com/LakshayD02/Lakshay_MacOS_Portfolio",
    webapp: "https://lakshay-macos.vercel.app/",
    member: [
     {
        img: "https://i.ibb.co/QFBQTdqt/Nextjs.png",
      },
       {
        img: "https://i.ibb.co/RyN9DQW/Type-Script.jpg",
      },
     {
        img: "https://i.ibb.co/v3MV4p3/tAILWIND.png",
      },
      {
        img: "https://i.ibb.co/wFHGWVLP/shadcn.png",
      },
    ],
  },
  {
    id: 15,
    title: "IIC - UDSC Website",
    date: "May 2025",
    description:
      "The IIC website serves as a platform to showcase the institute's programs, faculty, events, and other important information.",
    image:
      "https://i.ibb.co/LXJJM7W3/IICUDSC.png",
    category: "web app",
    github: "https://github.com/LakshayD02",
    webapp: "https://iic-udsc.vercel.app/",
    member: [
     {
        img: "https://i.ibb.co/QFBQTdqt/Nextjs.png",
      },
       {
        img: "https://i.ibb.co/RyN9DQW/Type-Script.jpg",
      },
     {
        img: "https://i.ibb.co/v3MV4p3/tAILWIND.png",
      },
      {
        img: "https://i.ibb.co/d4hG9tn/react-icon-2048x2048-o8k3ymqa.png",
      },
      {
        img: "https://i.ibb.co/YgR9gTS/emailjs.png",
      },
      {
        img: "https://i.ibb.co/wFHGWVLP/shadcn.png",
      },
      {
        img: "https://i.ibb.co/WvsqfM4r/Framer.png",
      },
    ],
  },
  {
    id: 11,
    title: "Full Stack Uber Clone",
    date: "January 2025",
    description:
      "This full stack (MERN) application emulates the core features of the popular ride-hailing service - Uber.",
    image:
      "https://i.ibb.co/Tz3wqdY/Project-uber.png",
    category: "web app",
    github: "https://github.com/LakshayD02/Full_Stack_Uber_Clone",
    webapp: "https://ridex-lakshay.vercel.app/",
    member: [
     {
        img: "https://i.ibb.co/v3MV4p3/tAILWIND.png",
      },
      {
        img: "https://i.ibb.co/d4hG9tn/react-icon-2048x2048-o8k3ymqa.png",
      },
      {
        img: "https://i.ibb.co/4tRMc8X/Mongo.png",
      },
      {
        img: "https://i.ibb.co/gTdrqbD/Express.png",
      },
      {
        img: "https://i.ibb.co/Yh7mRx1/Node.png",
      },
      {
        img: "https://i.ibb.co/XNv005B/Google-Maps.png",
      },
      {
        img: "https://i.ibb.co/CMCTKGn/socket.png",
      },
    ],
  },
  {
    id: 13,
    title: "IIC Placement Website",
    date: "June 2025",
    description:
      "A centralized platform to streamline and showcase placement-related information, including company drives, student opportunities.",
    image:
      "https://i.ibb.co/LDdYNL92/37.png",
    category: "web app",
    github: "https://github.com/LakshayD02",
    webapp: "https://iic-placement-website.vercel.app/",
    member: [
     {
        img: "https://i.ibb.co/QFBQTdqt/Nextjs.png",
      },
       {
        img: "https://i.ibb.co/RyN9DQW/Type-Script.jpg",
      },
     {
        img: "https://i.ibb.co/v3MV4p3/tAILWIND.png",
      },
      {
        img: "https://i.ibb.co/d4hG9tn/react-icon-2048x2048-o8k3ymqa.png",
      },
      {
        img: "https://i.ibb.co/YgR9gTS/emailjs.png",
      },
      {
        img: "https://i.ibb.co/wFHGWVLP/shadcn.png",
      },
      {
        img: "https://i.ibb.co/WvsqfM4r/Framer.png",
      },
    ],
  },
  {
    id: 11,
    title: "Blogger - Blog Application",
    date: " October 2024",
    description:
      "Blogger is a full stack web application designed for seamless blog management and user interaction.",
    image:
      "https://i.ibb.co/dbhFDTb/blogger.png",
    category: "web app",
    github: "https://github.com/LakshayD02/Full_Stack_Blog_Application_Flask",
    webapp: "https://github.com/LakshayD02/Full_Stack_Blog_Application_Flask/tree/main/Website%20Photos",
    member: [
      {
        img: "https://i.ibb.co/RBBy2Gf/HTML.webp",
      },
      {
        img: "https://i.ibb.co/476C50y/css.webp",
      },
      {
        img: "https://i.ibb.co/6s2gfSv/JS.png",
      },
      {
        img: "https://i.ibb.co/BNxnsjj/Bootstrap-logo-svg.png",
      },
      {
        img: "https://i.ibb.co/khnnhQ6/MySQL.png",
      },
      {
        img: "https://i.ibb.co/nQ6TwJn/Python.jpg",
      },
      {
        img: "https://i.ibb.co/SJY70jb/flask-tutorial.png",
      },
      
    ],
  },
  {
    id: 11,
    title: "CipherGPT - AI Chatbot",
    date: "July 2024",
    description:
      "CipherGPT is a powerful full-stack SaaS chatbot AI that leverages the cutting-edge OpenAI API.",
    image:
      "https://i.ibb.co/fYdwsWR/Project-13.png",
    category: "web app",
    github: "https://github.com/LakshayD02/FullStack_SaaS_ChatBot_CipherGPT",
    webapp: "https://ciphergpt-chatbot.vercel.app/",
    member: [
      {
        img: "https://i.ibb.co/v3MV4p3/tAILWIND.png",
      },
      {
        img: "https://i.ibb.co/d4hG9tn/react-icon-2048x2048-o8k3ymqa.png",
      },
      {
        img: "https://i.ibb.co/4tRMc8X/Mongo.png",
      },
      {
        img: "https://i.ibb.co/gTdrqbD/Express.png",
      },
      {
        img: "https://i.ibb.co/Yh7mRx1/Node.png",
      },
      {
        img: "https://i.ibb.co/RyN9DQW/Type-Script.jpg",
      },
      {
        img: "https://i.ibb.co/VDYZ4kn/Chatgpt.png",
      },
    ],
  },
  {
    id: 11,
    title: "Job Portal Website - MERN",
    date: "July 2024",
    description:
      "MERN Stack job portal where users can filter job listings by title, location, and posting time.",
    image:
      "https://i.ibb.co/Ctkzqy2/Project-1.png",
    category: "web app",
    github: "https://github.com/LakshayD02/MERN_Job_Portal_Website",
    webapp: "https://jobjunction-lakshay.vercel.app/",
    member: [
      {
        img: "https://i.ibb.co/v3MV4p3/tAILWIND.png",
      },
      {
        img: "https://i.ibb.co/d4hG9tn/react-icon-2048x2048-o8k3ymqa.png",
      },
      {
        img: "https://i.ibb.co/4tRMc8X/Mongo.png",
      },
      {
        img: "https://i.ibb.co/gTdrqbD/Express.png",
      },
      {
        img: "https://i.ibb.co/Yh7mRx1/Node.png",
      },
    ],
  },
  {
    id: 101,
    title: "Hostel Management Sys.",
    date: "August 2025",
    description:
      "It streamlines hostel operations, including room allotment, student registration, complaint tracking, and feedback management.",
    image:
      "https://i.ibb.co/G4ptfFnX/hostelm.png",
    category: "web app",
    github: "https://github.com/LakshayD02/Hostel-Management-System-PHP",
    webapp: "https://drive.google.com/file/d/1NJhdz871hI7mduj0fx6bE2iWhbJ5VR3m/view?usp=sharing",
    member: [
      {
        img: "https://i.ibb.co/RBBy2Gf/HTML.webp",
      },
      {
        img: "https://i.ibb.co/476C50y/css.webp",
      },
      {
        img: "https://i.ibb.co/6s2gfSv/JS.png",
      },
      {
        img: "https://i.ibb.co/tBwBxXT/JQUERY.png",
      },
      {
        img: "https://i.ibb.co/ZVss65P/AJAX.png",
      },
      {
        img: "https://i.ibb.co/khnnhQ6/MySQL.png",
      },
      {
        img: "https://i.ibb.co/9q6ZCv7/PHP.png",
      },
    ],
  },
  {
    id: 9,
    title: "MedTech - HMS",
    date: "July 2024",
    description:
      "Medtech is a HMS designed to modernize hospital operations by digitizing and automating various administrative tasks.",
    image:
      "https://i.ibb.co/bB3MFn0/Project-2.png",
    category: "web app",
    github: "https://github.com/LakshayD02/MedTech-Hospital-Management-System",
    webapp: "https://medtechhospital-lakshay.000webhostapp.com/",
    member: [
      {
        img: "https://i.ibb.co/RBBy2Gf/HTML.webp",
      },
      {
        img: "https://i.ibb.co/476C50y/css.webp",
      },
      {
        img: "https://i.ibb.co/6s2gfSv/JS.png",
      },
      {
        img: "https://i.ibb.co/tBwBxXT/JQUERY.png",
      },
      {
        img: "https://i.ibb.co/ZVss65P/AJAX.png",
      },
      {
        img: "https://i.ibb.co/khnnhQ6/MySQL.png",
      },
      {
        img: "https://i.ibb.co/9q6ZCv7/PHP.png",
      },
    ],
  },
  {
    id: 11,
    title: "SMS - Student Management",
    date: "June 2024",
    description:
      "SMS acts as the bottom line database to store and maintain all the daily school operations.",
    image:
      "https://i.ibb.co/4Mng3tk/Project-16.png",
    category: "web app",
    github: "https://github.com/LakshayD02/Student_Management_System",
    webapp: "https://studentmanagementsystem-lakshay.000webhostapp.com/",
    member: [
      {
        img: "https://i.ibb.co/RBBy2Gf/HTML.webp",
      },
      {
        img: "https://i.ibb.co/476C50y/css.webp",
      },
      {
        img: "https://i.ibb.co/6s2gfSv/JS.png",
      },
      {
        img: "https://i.ibb.co/tBwBxXT/JQUERY.png",
      },
      {
        img: "https://i.ibb.co/ZVss65P/AJAX.png",
      },
      {
        img: "https://i.ibb.co/khnnhQ6/MySQL.png",
      },
      {
        img: "https://i.ibb.co/9q6ZCv7/PHP.png",
      },
    ],
  },
  {
    id: 11,
    title: "Project Management Syst.",
    date: "June 2024",
    description:
      "It is a platform designed to help individuals and teams effectively plan, track, and manage projects.",
    image:
      "https://i.ibb.co/hRMrhrg/Project-14.png",
    category: "web app",
    github: "https://github.com/LakshayD02/Project-Management-System",
    webapp: "https://projectmanagement-lakshay.000webhostapp.com/",
    member: [
      {
        img: "https://i.ibb.co/RBBy2Gf/HTML.webp",
      },
      {
        img: "https://i.ibb.co/476C50y/css.webp",
      },
      {
        img: "https://i.ibb.co/6s2gfSv/JS.png",
      },
      {
        img: "https://i.ibb.co/tBwBxXT/JQUERY.png",
      },
      {
        img: "https://i.ibb.co/ZVss65P/AJAX.png",
      },
      {
        img: "https://i.ibb.co/khnnhQ6/MySQL.png",
      },
      {
        img: "https://i.ibb.co/9q6ZCv7/PHP.png",
      },
    ],
  },
  {
    id: 10,
    title: "Movie Booking System",
    date: "June 2024",
    description:
      "INOX Theatre Movie Booking is a online movie booking platform, designed to emulate the INOX theatre experience in Rajouri Garden.",
    image:
      "https://i.ibb.co/GM63w8M/Project-3.png",
    category: "web app",
    github: "https://github.com/LakshayD02/INOX-Theatre-Movie-Booking-System",
    webapp: "https://inoxtheatre-lakshay.000webhostapp.com",
    member: [
      {
        img: "https://i.ibb.co/RBBy2Gf/HTML.webp",
      },
      {
        img: "https://i.ibb.co/476C50y/css.webp",
      },
      {
        img: "https://i.ibb.co/6s2gfSv/JS.png",
      },
      {
        img: "https://i.ibb.co/tBwBxXT/JQUERY.png",
      },
      {
        img: "https://i.ibb.co/ZVss65P/AJAX.png",
      },
      {
        img: "https://i.ibb.co/khnnhQ6/MySQL.png",
      },
      {
        img: "https://i.ibb.co/9q6ZCv7/PHP.png",
      },
    ],
  },
  {
    id: 8,
    title: "LMS - Library Management",
    date: "May 2024",
    description:
      "The LMS organizes and maintains book information electronically. It has both student and admin modules.",
    image:
      "https://i.ibb.co/m42qRh1/lms.png",
    category: "web app",
    github: "https://github.com/LakshayD02/The-Library-Zone_LMS",
    webapp: "https://screenrec.com/share/xAaJXz6NRd",
    member: [
      {
        img: "https://i.ibb.co/RBBy2Gf/HTML.webp",
      },
      {
        img: "https://i.ibb.co/476C50y/css.webp",
      },
      {
        img: "https://i.ibb.co/6s2gfSv/JS.png",
      },
      {
        img: "https://i.ibb.co/tBwBxXT/JQUERY.png",
      },
      {
        img: "https://i.ibb.co/ZVss65P/AJAX.png",
      },
      {
        img: "https://i.ibb.co/khnnhQ6/MySQL.png",
      },
      {
        img: "https://i.ibb.co/9q6ZCv7/PHP.png",
      },
    ],
  },
  {
    id: 8,
    title: "E-commerce Store App",
    date: "April 2024",
    description:
      "The application allows the customer to shop virtually and allow customers to buy the items and articles of their desire from the store.",
    image:
      "https://i.ibb.co/PQfXQFr/Project-7.png",
    category: "web app",
    github: "https://github.com/LakshayD02/Online_Shopping_Website",
    webapp: "https://onlineshoppingwebsite-lakshay.000webhostapp.com/",
    member: [
      {
        img: "https://i.ibb.co/RBBy2Gf/HTML.webp",
      },
      {
        img: "https://i.ibb.co/476C50y/css.webp",
      },
      {
        img: "https://i.ibb.co/6s2gfSv/JS.png",
      },
      {
        img: "https://i.ibb.co/tBwBxXT/JQUERY.png",
      },
      {
        img: "https://i.ibb.co/ZVss65P/AJAX.png",
      },
      {
        img: "https://i.ibb.co/khnnhQ6/MySQL.png",
      },
      {
        img: "https://i.ibb.co/9q6ZCv7/PHP.png",
      },
    ],
  },
  {
    id: 7,
    title: "Notes Sharing System",
    date: "March 2024",
    description:
      "The system offers a robust platform for users to create accounts, sign in securely, and share their notes effortlessly by uploading files.",
    image:
      "https://i.ibb.co/NYw3M09/Project-8.png",
    category: "web app",
    github: "https://github.com/LakshayD02/Online_Notes_Sharing_System",
    webapp: "https://notesapp-onss.000webhostapp.com/",
    member: [
      {
        img: "https://i.ibb.co/RBBy2Gf/HTML.webp",
      },
      {
        img: "https://i.ibb.co/476C50y/css.webp",
      },
      {
        img: "https://i.ibb.co/6s2gfSv/JS.png",
      },
      {
        img: "https://i.ibb.co/tBwBxXT/JQUERY.png",
      },
      {
        img: "https://i.ibb.co/ZVss65P/AJAX.png",
      },
      {
        img: "https://i.ibb.co/khnnhQ6/MySQL.png",
      },
      {
        img: "https://i.ibb.co/9q6ZCv7/PHP.png",
      },
    ],
  },
  {
    id: 6,
    title: "E-Learning Website",
    date: "December 2023",
    description:
      "Students can access free courses on this E-learning website and learn online with its assistance.",
    image:
      "https://i.ibb.co/wzjL9zw/Project-4.png",
    category: "web app",
    github: "https://github.com/LakshayD02/E-Learning_Website",
    webapp: "https://elearningwebportal.000webhostapp.com/",
    member: [
      {
        img: "https://i.ibb.co/RBBy2Gf/HTML.webp",
      },
      {
        img: "https://i.ibb.co/476C50y/css.webp",
      },
      {
        img: "https://i.ibb.co/6s2gfSv/JS.png",
      },
      {
        img: "https://i.ibb.co/tBwBxXT/JQUERY.png",
      },
      {
        img: "https://i.ibb.co/ZVss65P/AJAX.png",
      },
      {
        img: "https://i.ibb.co/khnnhQ6/MySQL.png",
      },
      {
        img: "https://i.ibb.co/9q6ZCv7/PHP.png",
      },
    ],
  },
  {
    id: 5,
    title: "BikeThrills - Bike Renting",
    date: "March 2023",
    description:
      "A Responsive Bike Renting Website with Database which helps users rent bikes on rent on a daily basis",
    image:
      "https://i.ibb.co/6wqNRY8/Project-5.png",
    category: "web app",
    github: "https://github.com/LakshayD02/Bikethrills-Website",
    webapp: "https://bikethrills.000webhostapp.com/",
    member: [
      {
        img: "https://i.ibb.co/RBBy2Gf/HTML.webp",
      },
      {
        img: "https://i.ibb.co/476C50y/css.webp",
      },
      {
        img: "https://i.ibb.co/6s2gfSv/JS.png",
      },
      {
        img: "https://i.ibb.co/tBwBxXT/JQUERY.png",
      },
      {
        img: "https://i.ibb.co/ZVss65P/AJAX.png",
      },
      {
        img: "https://i.ibb.co/khnnhQ6/MySQL.png",
      },
      {
        img: "https://i.ibb.co/9q6ZCv7/PHP.png",
      },
    ],
  },
  {
    id: 51,
    title: "LuxKeys: Keyboard SaaS",
    date: "June 2025",
    description:
      "LuxKeys is a modern, responsive e-commerce website for premium mechanical keyboards, built with Next.js and React.",
    image:
      "https://i.ibb.co/45HWPWd/Luxkeys.png",
    category: "machine learning",
    github: "https://github.com/LakshayD02/Luxkeys_Keyboard_SaaS_Brand",
    webapp: "https://luxkeys-keyboard-brand-lakshay.vercel.app/",
    member: [
     {
        img: "https://i.ibb.co/QFBQTdqt/Nextjs.png",
      },
       {
        img: "https://i.ibb.co/RyN9DQW/Type-Script.jpg",
      },
     {
        img: "https://i.ibb.co/v3MV4p3/tAILWIND.png",
      },
      {
        img: "https://i.ibb.co/wFHGWVLP/shadcn.png",
      },
      {
        img: "https://i.ibb.co/WvsqfM4r/Framer.png",
      },
    ],
  },
  {
    id: 52,
    title: "Taskflow: To-Do",
    date: "August 2025",
    description:
      "A to-do list application that helps users organize tasks by categories such as Work, Personal, Health, Learning, Shopping, and more.",
    image:
      "https://i.ibb.co/N2VDRb5x/38.png",
    category: "machine learning",
    github: "https://github.com/LakshayD02/Taskflow-Pro-Todo-List",
    webapp: "https://taskflow-todo-list.vercel.app/",
    member: [
     {
        img: "https://i.ibb.co/QFBQTdqt/Nextjs.png",
      },
       {
        img: "https://i.ibb.co/RyN9DQW/Type-Script.jpg",
      },
     {
        img: "https://i.ibb.co/v3MV4p3/tAILWIND.png",
      },
      {
        img: "https://i.ibb.co/wFHGWVLP/shadcn.png",
      },
      {
        img: "https://i.ibb.co/WvsqfM4r/Framer.png",
      },
       {
        img: "https://i.ibb.co/WvTg90S/react-icon-2048x2048-o8k3ymqa.png",
      },
    ],
  },
  {
    id: 5,
    title: "Rapid Chat - WhatsApp",
    date: "February 2024",
    description:
      "It is designed to streamline the initiation of conversations on WhatsApp without the need to save contacts in your phone's directory.",
    image:
      "https://i.ibb.co/THjSMfj/Project-9.png",
    category: "machine learning",
    github: "https://github.com/LakshayD02/Rapid-Chat_Whatsapp",
    webapp: "https://rapid-chat-whatsapp.vercel.app/",
    member: [
      {
        img: "https://i.ibb.co/RBBy2Gf/HTML.webp",
      },
      {
        img: "https://i.ibb.co/476C50y/css.webp",
      },
      {
        img: "https://i.ibb.co/6s2gfSv/JS.png",
      },
      {
        img: "https://i.ibb.co/WvTg90S/react-icon-2048x2048-o8k3ymqa.png",
      },
    ],
  },
  {
    id: 5,
    title: "GitHunt - Github Finder",
    date: "February 2024",
    description:
      "With Githunt, users can effortlessly search for GitHub profiles by name or username.",
    image:
      "https://i.ibb.co/jTcDZVX/Project-12.png",
    category: "machine learning",
    github: "https://github.com/LakshayD02/GitHunt_Github_Finder",
    webapp: "https://githunt-lakshay.vercel.app/",
    member: [
      {
        img: "https://i.ibb.co/RBBy2Gf/HTML.webp",
      },
      {
        img: "https://i.ibb.co/476C50y/css.webp",
      },
      {
        img: "https://i.ibb.co/6s2gfSv/JS.png",
      },
      {
        img: "https://i.ibb.co/WvTg90S/react-icon-2048x2048-o8k3ymqa.png",
      },
    ],
  },
  {
    id: 4,
    title: "YouTube Clone",
    date: "February 2024",
    description:
      "Explore this ReactJS YouTube clone built with stunning Material UI and RapidAPI to fetch real video data and implement search.",
    image:
      "https://i.ibb.co/BzZPYYg/Project-10.png",
    category: "machine learning",
    github: "https://github.com/LakshayD02/Youtube_Clone_React_RapidAPI",
    webapp: "https://youtube-clone-lakshay.vercel.app/",
    member: [
      {
        img: "https://i.ibb.co/RBBy2Gf/HTML.webp",
      },
      {
        img: "https://i.ibb.co/476C50y/css.webp",
      },
      {
        img: "https://i.ibb.co/6s2gfSv/JS.png",
      },
      {
        img: "https://i.ibb.co/WvTg90S/react-icon-2048x2048-o8k3ymqa.png",
      },
    ],
  },
  {
    id: 3,
    title: "Real-Time Weather App",
    date: "January 2024",
    description:
      "It enables users to search for weather conditions worldwide and delivers current weather information.",
    image:
      "https://i.ibb.co/SfwN21k/Project-11.png",
    category: "machine learning",
    github: "https://github.com/LakshayD02/React-Weather-App",
    webapp: "https://react-weatherapp-lakshay.vercel.app/",
    member: [
      {
        img: "https://i.ibb.co/RBBy2Gf/HTML.webp",
      },
      {
        img: "https://i.ibb.co/476C50y/css.webp",
      },
      {
        img: "https://i.ibb.co/6s2gfSv/JS.png",
      },
      {
        img: "https://i.ibb.co/WvTg90S/react-icon-2048x2048-o8k3ymqa.png",
      },
    ],
  },
  {
  id: 112,
    title: "BypassX: AI-Evasion Tool",
    date: "September 2025",
    description:
      "It simulates various attack vectors while employing multiple evasion strategies to bypass AI-powered detection systems.",
    image:
      "https://i.ibb.co/xtQHkr78/bypassx.png",
    category: "android app",
    github: "https://github.com/LakshayD02/BypassX-AI-Evasion-Tool-Python.git",
    webapp: "https://github.com/LakshayD02/BypassX-AI-Evasion-Tool-Python.git",
    member: [
      {
        img: "https://i.ibb.co/nQ6TwJn/Python.jpg",
      },
      {
        img: "https://i.ibb.co/6711tKXj/Scikit.png",
      },
      {
        img: "https://i.ibb.co/qLPGKyNs/pytorch.png",
      },
      {
        img: "https://i.ibb.co/GvN9Nv6K/numpy.png",
      },
      {
        img: "https://i.ibb.co/CKwNtkxP/pandas.png",
      },
      {
        img: "https://i.ibb.co/5hjbDYxt/matplotlib.png",
      },
    ],
  },
  {
    id: 2,
    title: "NLP Generation AI Model",
    date: "November 2024",
    description:
      "It leverages a pre-trained language model (GPT-2) to generate human-like text based on user prompts.",
    image:
      "https://i.ibb.co/5YS1xZz/NLP-Model.png",
    category: "android app",
    github: "https://github.com/LakshayD02/Natural_Language_Generation_AIModel_Python",
    webapp: "https://github.com/LakshayD02/Natural_Language_Generation_AIModel_Python/blob/main/NLP-2.png",
    member: [
      {
        img: "https://i.ibb.co/nQ6TwJn/Python.jpg",
      },
      {
        img: "https://i.ibb.co/vQrpHrV/AIP.png",
      },
      {
        img: "https://i.ibb.co/9YMqxzF/HFT.png",
      },
      {
        img: "https://i.ibb.co/3SyGNW9/tkinter.png",
      },
      {
        img: "https://i.ibb.co/6DtB8yF/gpt-2.png",
      },
    ],
  },
  {
    id: 2,
    title: "Flappy Bird Game",
    date: "October 2023",
    description:
      "An endless game that includes a bird controlled by the player. The objective of this game is to prevent the bird from falling on the ground.",
    image:
      "https://i.ibb.co/mJjs0hy/Flappy.webp",
    category: "android app",
    github: "https://github.com/LakshayD02/FlappyBirdGame-Python",
    webapp: "https://bit.ly/3PesZjk",
    member: [
      {
        img: "https://i.ibb.co/nQ6TwJn/Python.jpg",
      },
    ],
  },
  {
    id: 1,
    title: "Pathfinding Visualize Tool",
    date: "September 2024",
    description:
      "It allows users to visualize the behavior of two popular pathfinding algorithms: A* and BFS.",
    image:
      "https://i.ibb.co/mzXKMY5/PVT.png",
    category: "android app",
    github: "https://github.com/LakshayD02/Pathfinding_Visualization_Tool_Python",
    webapp: "https://github.com/LakshayD02/Pathfinding_Visualization_Tool_Python/raw/main/A-Star%20Algorithm.png",
    member: [
      {
        img: "https://i.ibb.co/nQ6TwJn/Python.jpg",
      },
      {
        img: "https://i.ibb.co/wcdzxbM/pygame.png",
      },
    ],
  },
  {
    id: 0,
    title: "Handwriting Recognition App",
    date: "December 2023",
    description:
      "A simple AI model that can recognize handwritten digits built using python.",
    image:
      "https://i.ibb.co/7W6QJtF/HDR.png",
    category: "android app",
    github: "https://github.com/LakshayD02/Handwritten_Digital_Recognition",
    webapp: "https://github.com/LakshayD02/Handwritten_Digital_Recognition/blob/main/Handwritten%20Digital%20Recognition.pdf",
    member: [
      {
        img: "https://i.ibb.co/nQ6TwJn/Python.jpg",
      },
      {
        img: "https://i.ibb.co/vQrpHrV/AIP.png",
      },
    ],
  },
];
